// extracted by mini-css-extract-plugin
export default {"table":"BPipelineTable-module_table_d59b9be5","breakWords":"BPipelineTable-module_breakWords_cce5d281"};